import { getApi, patchApi, postApi } from '../../utils/api'

export function readPost(id) {
  return postApi({ endpoint: `/api/v2/newsband/${id}/read/` })
}

export function getNewsboardPostProfile(id) {
  return getApi({ endpoint: `/api/v2/newsband/${id}/` })
}

export function updateNewsboard(id, data) {
  return patchApi({ data, endpoint: `/api/v2/newsband/${id}/` })
}

export function getFeedbackByUuid(id) {
  return getApi({ endpoint: `api/v2/newsband-feedback/${id}/` })
}

export function createFeedback(data) {
  return postApi({ data, endpoint: 'api/v2/newsband-feedback/' })
}

export function updateFeedback(id, data) {
  return patchApi({ data, endpoint: `api/v2/newsband-feedback/${id}/` })
}

export function getPostReportLikes(id, data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/news/posts/${id}/report/likes/`,
  })
}

export function getPostReportViews(id, data) {
  return postApi({
    data,
    endpoint: `idwell-api/api/v3/news/posts/${id}/report/views/`,
  })
}

export function reportLikesExport(id) {
  return postApi({
    endpoint: `api/post/${id}/likes/export/`,
  })
}

export function reportViewsExport(id) {
  return postApi({
    endpoint: `api/post/${id}/views/export/`,
  })
}

export function checkReportLikesExportTask(taskId, postId) {
  return getApi({
    endpoint: `api/post/${postId}/likes/export/task/${taskId}/`,
  })
}

export function checkReportViewsExportTask(taskId, postId) {
  return getApi({
    endpoint: `api/post/${postId}/views/export/task/${taskId}/`,
  })
}
